export default [
  {
    title: 'Dashboard',
    route: 'dashboard',
    icon: 'HomeIcon',
  },
  {
    title: 'Post Search',
    route: 'post-search',
    icon: 'SearchIcon',
  },
  {
    title: 'Contacts',
    route: 'contacts',
    icon: 'UsersIcon',
  },
  {
    title: 'Post Replies',
    faIcon: 'fas fa-reply',
    route: 'digital-replies',
  },
]
